<template>
    <div class="order_box" v-if="datas">
        <div class="order_title">订单详情</div>
        <el-row :gutter="40" class="order_content">
            <el-col :span="12">
                <dl>
                    <dt>订单信息</dt>
                    <dd><span>订单编号：</span>{{ datas.orders_sn }}</dd>
                    <dd><span>商品规格：</span>{{ datas.orders_goods[0].goods_spec_name }}</dd>
                    <dd><span>用户手机：</span>{{ datas.buyers_mobile }}</dd>
                    <dd v-if="datas.orders_goods"><span>商品名称：</span>{{ datas.orders_goods[0].goods_names }}</dd>
                    <dd v-if="datas.orders_goods"><span>数量：</span>{{ datas.orders_goods[0].goods_number }}</dd>
                    <dd><span>销售价：</span>{{ datas.orders_goods[0].goods_payments_amounts }}元</dd>
                    <dd><span>总价：</span>{{ datas.goods_payments_amounts }}元</dd>
                    <dd><span>优惠券：</span>{{ datas.coupons_discounts_amounts }}元</dd>
                    <dd><span>快递费：</span>{{ datas.posts_fees }}元</dd>
                    <dd><span>支付金额：</span>{{ datas.payments_amounts }}元</dd>
                    <dd>
                        <span>订单状态：</span
                        >{{
                            datas.orders_status == 1
                                ? "待付款"
                                : datas.orders_status == 2
                                ? "待发货"
                                : datas.orders_status == 3
                                ? "待收货"
                                : datas.orders_status == 4
                                ? "待评论"
                                : datas.orders_status == 5
                                ? "已取消"
                                : datas.orders_status == 6
                                ? "已完成"
                                : datas.orders_status == 7
                                ? "已取消"
                                : "-"
                        }}
                    </dd>
                </dl>
            </el-col>
            <el-col :span="12">
                <dl>
                    <dt>支付信息</dt>
                    <dd><span>支付状态：</span>{{ datas.trades_status == 1 ? "未支付" : datas.trades_status == 2 ? "付款中" : datas.trades_status == 3 ? "已支付" : datas.trades_status || "-" }}</dd>
                    <dd><span>支付方式：</span>{{ datas.payments_codes == "AliPay" ? "支付宝" : datas.payments_codes || "-" }}</dd>
                    <dd><span>支付时间：</span>{{ datas.payments_times || "-" }}</dd>
                </dl>
                <dl>
                    <dt>物流信息</dt>
                    <dd><span>发货时间：</span>{{ datas.consignments_times }}</dd>
                    <!--  <dd v-if="datas.orders_deliveries"><span>快递公司：</span>{{ datas.orders_deliveries.express_company ||"-" }}</dd>
                    <dd v-if="datas.orders_deliveries"><span>快递单号：</span>{{ datas.orders_deliveries.express_no || "-" }}</dd> -->
                    <dd v-if="datas.orders_deliveries"><span>收货人：</span>{{ datas.orders_deliveries.receivers_names || "-" }}</dd>
                    <dd v-if="datas.orders_deliveries">
                        <span>联系电话：</span
                        >
                        {{
                          datas.orders_deliveries.receivers_mobiles 
                        }}
                      <!--   {{
                            datas.orders_deliveries.receivers_mobiles == "" || datas.orders_deliveries.receivers_mobiles == null
                                ? datas.orders_deliveries.receivers_phones
                                : datas.orders_deliveries.receivers_mobiles
                        }} -->
                    </dd>
                    <dd v-if="datas.orders_deliveries">
                        <span>收货地址：</span>
                        {{
                            datas.orders_deliveries.receivers_provinces +
                            datas.orders_deliveries.receivers_citys +
                            datas.orders_deliveries.receivers_districts +
                            datas.orders_deliveries.receivers_address
                        }}
                    </dd>
                </dl>
            </el-col>
        </el-row>
        <div class="closeDetail">
            <el-button type="primary" @click="hides" size="medium">关闭</el-button>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {};
    },
    props: {
        datas: {
            typeof: Object,
        },
    },
    created() {
    },
    comments: {},
    methods: {
        ...mapActions({
            getExpro: "commodity/getExpro",
        }),
        // getkd(id){
        //   console.log(id,'id')
        //    this.getExpro({
        //       token :this.$store.state.token,
        //       id : id
        //      }).then((res)=>{
        //        console.log(res.data.tits);
        //          if(res.code==1){
        //             return res.data.tits;
        //          }else{
        //            this.$message.error(res.msg);
        //          }
        //      })
        // },
        hides() {
            this.$emit("hide");
        },
    },
};
</script>

<style lang='scss' scoped>
.order_box {
    border-width: 0px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1058px;
    background: inherit;
    background-color: rgba(76, 81, 125, 0.933333333333333);
    border: none;
    border-radius: 10px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 30px;
    z-index: 999;
    .order_title {
        font-size: 24px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
        margin-bottom: 30px;
    }
    .order_content {
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        color: rgba(255, 255, 255, 0.8);
        dl {
            dt {
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 24px;
            }
            dd {
                margin-bottom: 14px;
                font-size: 16px;
                text-indent: 1em;
                display: flex;
                justify-content: flex-start;
                span {
                    flex-shrink: 0;
                    width: 140px;
                    text-align: left;
                    display: inline-block;
                }
            }
        }
    }
    .closeDetail {
        text-align: center;
        margin-top: 20px;
        .el-button {
            width: 200px;
            background: rgba(70, 50, 214, 1);
            border-color: rgba(70, 50, 214, 1);
        }
        .el-button:hover {
            background: rgba(70, 50, 214, 0.8);
            border-color: rgba(70, 50, 214, 0.8);
        }
    }
}
</style>